import ProductAPI from '@/api/product'
import RecentAPI from '@/api/recent'
import Cookies from 'js-cookie'
import { isLogin } from '@/utils'

const setRecentProductList = commit => responseData => {
  const { data } = responseData
  commit(
    'SET_RECENT_PRODUCT_LIST',
    data.recentlyViewedProductList || data.productList || []
  )
}

/**
 * 최근 본 상품을 추가한다.
 * @param {*} param0
 * @param {Array} productIds - 제품 id 배열
 */
const addRecentProducts = ({ state, commit }, productIds) => {
  // 로그인 시 API call
  if (isLogin()) {
    RecentAPI.addRecentProducts(productIds)
  } else {
    let recent = Cookies.get('recent') || ''
    productIds.forEach(productId => {
      recent = `${productId},` + recent.replace(`${productId},`, '')
      Cookies.set('recent', recent, { expires: 14, domain: 'nexon.com' })
    })
  }
}
/**
 * 최근 본 상품 중 특정 상품을 제거한다
 * @param {*} param0
 * @param {Numer} productId - 제품 id
 */
const removeRecentProduct = ({ state, commit }, productId) => {
  if (isLogin()) {
    RecentAPI.removeRecentProduct(productId, responseData => {
      commit('REMOVE_RECENT_PRODUCT', productId)
    })
  } else {
    let recent = Cookies.get('recent') || ''
    recent = recent.replace(`${productId},`, '')
    Cookies.set('recent', recent, { expires: 14, domain: 'nexon.com' })
    commit('REMOVE_RECENT_PRODUCT', productId)
  }
}
/**
 * 최근 본 상품 목록을 요청한다.
 * @param {*} param0
 */
const getRecentProductList = ({ state, commit, dispatch }) => {
  // 로그인 / 비로그인 상관 없이 API call
  // RecentAPI.getRecentProductList(setRecentProductList(commit))

  let recent = Cookies.get('recent') || ''
  const productIds = recent.length
    ? recent.split(',').map(el => Number(el))
    : []
  productIds.pop() // 맨 마지막은 빈 값이라 제거
  if (productIds.length) {
    // 로그인 되어 있을땐
    if (isLogin()) {
      RecentAPI.addRecentProducts(productIds, () => {
        Cookies.set('recent', '', { expires: 14, domain: 'nexon.com' })
        dispatch('getRecentProductList') // 재귀 호출
      })
    } else {
      ProductAPI.getProductListByIds(productIds, setRecentProductList(commit))
    }
  } else if (isLogin()) {
    RecentAPI.getRecentProductList(setRecentProductList(commit))
  }
}

export default {
  addRecentProducts,
  removeRecentProduct,
  getRecentProductList
}
